module.exports = __webpack_public_path__ + "static/media/lemon.6b885461.jpg";